const MegaMenu = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const megaMenu = document.querySelector('.primary-header__menu');
        const header = document.querySelector('.header');
      
        const updateMegaMenuPosition = () => {
          if (header && megaMenu) {
            // Get the height of .header
            const headerHeight = header.offsetHeight;
      
            // Set the --mega-menu-top custom property to the header height
            megaMenu.style.setProperty('--mega-menu-top', `${headerHeight}px`);
          }

        };
        
        // Initial call to set the position
        updateMegaMenuPosition();
      
        // Update the position on window resize
        window.addEventListener('resize', updateMegaMenuPosition);
      });
};

export default MegaMenu;